import Typography from '@mui/material/Typography'
import StyledButton from '../../generic/StyledButton'
import Tooltip from '@mui/material/Tooltip'
import { useEffect, useState } from 'react'
import BulkApprovalsModal from './BulkApprovalsModal'

const BulkApprovalButton = ({ tableData, updateBulkPaymentRequests, selectedRowIds = [] }) => {
  const [selectedRowObjects, setSelectedRowObjects] = useState([])
  const [modalVisible, setModalVisible] = useState(false)

  const buttonStyleProps = {
    fontSize: 14,
    padding: 0.5,
  }

  useEffect(() => {
    if (selectedRowIds.length <= 0) {
      return
    }

    // this seems like the easiest way to get pull objects from an array based on an array of ids
    const selectedPRs = tableData.filter((row) => {
      if (selectedRowIds.includes(row.id)) {
        return true
      }
      return false
    })

    setSelectedRowObjects(selectedPRs)
  }, [selectedRowIds])

  return (
    <>
      {selectedRowIds.length <= 0 ? (
        <Tooltip title={<Typography>{'No rows selected'}</Typography>} arrow>
          <span>
            <StyledButton disabled customTheme='outlined' {...buttonStyleProps}>
              Approve Selected Rows
            </StyledButton>
          </span>
        </Tooltip>
      ) : (
        <StyledButton onClick={() => setModalVisible(true)} {...buttonStyleProps}>
          Approve Selected Rows
        </StyledButton>
      )}
      {modalVisible && (
        <BulkApprovalsModal
          modalVisible={modalVisible}
          handleCancelModal={() => setModalVisible(false)}
          selectedRowObjects={selectedRowObjects}
          updateBulkPaymentRequests={updateBulkPaymentRequests}
        />
      )}
    </>
  )
}

export default BulkApprovalButton
